// extracted by mini-css-extract-plugin
export default {"outsideOval":"style_outsideOval__kvtNX","insideOval":"style_insideOval__DR3L0"};